import { Vue,Component,Prop,Watch} from 'vue-property-decorator';
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';

@Component({
    components: {
        EmptyGraphMessage,
    }
})

export default class PastPerformanceModal extends Vue {

    @Prop() isShowPastPerformanceModal!: boolean
    @Prop() workUnitId!: string
    private screen = "PASTPERFORMANCEBYPLANTING";
    private headers = [] as any[];
    private workers = [] as any[];
    private agriFields = [] as any[];
    private crops = [] as any[];
    private plantings = [] as any[];
    private workItems = [] as any[];
    private selectedCropId: string | null = null;
    private selectedPlantingId: string | null = null;
    private selectedAgriFieldId : string | null = null;
    private selectedWorkItemId : string | null = null;
    private selectedWorkUnitIdToShare: string | null = null;
    private loading = false;
    private includeHiddenFlag = false;
    private performancesToShare = [] as any[];
    private selectedWorkUnitName = ''

    @Watch('isShowPastPerformanceModal')
    private showPerformance(){
        if (this.isShowPastPerformanceModal) {
            this.getCrops();
            this.getPlantings();
            this.getAgriFields(); 
            this.getWorkItems();
            this.getWorkUnit();
            this.getPastPerformance();
        }
    }

    @Watch('selectedWorkUnitIdToShare')
    private selectPerformanceInSp() {
        this.selectPerformance(this.selectedWorkUnitIdToShare);
    }

    selectPerformance(id: any) {
        if (id != null) {
            this.performancesToShare = this.workers.map(worker => {
                const performanceValue = worker.performance[id];
                return performanceValue !== undefined ? { workerId: worker.workerId, performance: performanceValue } : null;
            }).filter(item => item !== null);
        }
        this.closeModal();
    }

    getPastPerformance() {
        if (this.workUnitId && this.workUnitId != null) {
            this.$apiClient.doRequest('get', `/admin/past_performance_by_planting/${this.workUnitId}`).then(res => {
                this.selectedCropId = res.searchConditions.cropId
                this.selectedPlantingId = res.searchConditions.plantingId
                this.selectedAgriFieldId = res.searchConditions.agriFieldId
                this.selectedWorkItemId = res.searchConditions.workItemId
                this.includeHiddenFlag = res.searchConditions.includeHiddenFlag
                const workUnitMap = new Map<string, { workUnitId: string; workUnitName: string; title: string | null }>();
                const workersById: Record<string, { workerId: string; workerName: string; performance: Record<string, number> }> = {};
                res.performances.forEach((item: { workUnitId: string; workUnitName: string; title: any; workerId: string; workerName: string; performance: number; }) => {
                    if (!workUnitMap.has(item.workUnitId)) {
                        workUnitMap.set(item.workUnitId, {
                            workUnitId: item.workUnitId,
                            workUnitName: item.workUnitName,
                            title: item.title
                        });
                    }
                    if (!workersById[item.workerId]) {
                        workersById[item.workerId] = {
                            workerId: item.workerId,
                            workerName: item.workerName,
                            performance: {}
                        };
                    }
                    workersById[item.workerId].performance[item.workUnitId] = item.performance;
                });
                this.headers = Array.from(workUnitMap.values());
                this.workers = Object.values(workersById);
                this.loading = false;
            }).catch(error=>{
                this.$toasted.error('データの取得に失敗しました。')
                this.loading = false;
            })
        }
    }

    getCrops() {
        this.$apiClient.doRequest('get', '/crops/cropBytenentId').then(res => {
            this.crops = res.crops.sort((a: any, b: any) => a.name.localeCompare(b.name));
        });
    }
    
    getPlantings() {
        this.$apiClient.doRequest('get', '/plantings?with_hidden=true').then(res => {
            this.plantings = res.plantings.sort((a: any, b: any) => a.name.localeCompare(b.name));
        });
    }

    private getWorkUnit() {
        this.$apiClient.doRequest("get", `/work_units/${this.workUnitId}`).then((res: any) => { 
            this.selectedWorkUnitName = res.name; 
        });        
    }

    get filteredPlantings() {
        if (this.selectedCropId === null) {
            return this.includeHiddenFlag ? this.plantings : this.plantings.filter(p => this.selectedPlantingId == p.id || !p.is_hidden);
        } else {
            return this.includeHiddenFlag ? this.plantings.filter(p => p.crop.id === this.selectedCropId) : this.plantings.filter(p => this.selectedPlantingId == p.id || (!p.is_hidden && p.crop.id === this.selectedCropId));
        }
    }

    getAgriFields() {
        this.$apiClient.doRequest('get', '/agri_fields?with_hidden=true').then((res) => {
            this.agriFields = res.agri_fields
        })        
    }

    get filteredAgriFields() {
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    }

    getWorkItems() {
        this.$apiClient.doRequest('get','/work_items?with_hidden=true').then((res) => {
            this.workItems = res.work_items
        })
    }

    get filteredWorkItems() {
        return this.includeHiddenFlag ? this.workItems : this.workItems.filter(wi => this.selectedWorkItemId == wi.id || !wi.is_hidden);
    }

    handleCropSelect() {
        this.selectedPlantingId = null
    }

    handlePlantingSelect() {
        if (this.selectedPlantingId != null) {
            const selectedPlanting = this.plantings.find(p => p.id === this.selectedPlantingId);
            if (selectedPlanting) {
                this.selectedCropId = selectedPlanting.crop.id;
            }
        }
    }

    closeModal() {
        this.$emit('update:isShowPastPerformanceModal', this.performancesToShare);
        this.reset();
    }

    reset() {
        this.selectedAgriFieldId = null;
        this.selectedCropId = null;
        this.selectedPlantingId = null;
        this.selectedWorkItemId = null;
        this.crops = [];
        this.plantings = [];
        this.agriFields = [];
        this.workItems = [];
        this.headers = [];
        this.workers = [];
        this.selectedWorkUnitIdToShare = null;
        this.performancesToShare = [];
    }

    requiredFieldCheck() {
        const requiredCheck = [];
        if (!this.selectedCropId) {
            requiredCheck.push('作目を選択してください。');
        }
        if (!this.selectedWorkItemId) {
            requiredCheck.push('作業項目を選択してください。');
        }
        return requiredCheck;
    }

    handleSearchClick() {
        const conditions = this.requiredFieldCheck();
        if (conditions.length > 0) {
            window.alert(conditions.join('\n'));
        } else {
            const params = {
                cropId: this.selectedCropId,
                plantingId: this.selectedPlantingId,
                agriFieldId: this.selectedAgriFieldId,
                selectedWorkId: this.selectedWorkItemId,
                includeHiddenFlag: this.includeHiddenFlag,
                screenName: this.screen,
            }
            this.$apiClient.doRequest('post', `/graphScreenManagement`,params).then(res => {
                this.workers = [];
                this.headers = [];
                this.loading = true;
                this.getPastPerformance();
            }).catch(error=>{
                this.$toasted.error('データの取得に失敗しました。')
                this.loading = false;
            })
        }
    }
}